"use client";

import { Navbar } from "@/components/navigation/Navbar";
import type { HeaderProps } from "@/lib/sections/header.types";

export function HeaderSection({
  title,
  links,
  sticky = true,
  transparent = false,
  cta,
}: HeaderProps) {
  const navItems =
    links?.map((link) => ({
      label: link.label,
      href: link.href,
    })) ?? [];

  const headerCta = cta
    ? {
        label: cta.label,
        href: cta.href,
      }
    : undefined;

  return (
    <Navbar
      brand={title}
      navItems={navItems}
      cta={headerCta}
      sticky={sticky}
      transparent={transparent}
    />
  );
}
